import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {SVGIcon} from '@homeaway/react-svg';
import {ARROW_RIGHT__24} from '@homeaway/svg-defs';
import classNames from 'classnames';
import Label from './Label';
import './style.less';

export default class CheckInCheckOut extends PureComponent {
    static propTypes = {
        /** CheckIn label text */
        checkInLabel: PropTypes.string,
        /** CheckOut label text */
        checkOutLabel: PropTypes.string,
        /** checkIn date: DD-MM-YYYY */
        checkIn: PropTypes.string,
        /** checkOut date: DD-MM-YYYY */
        checkOut: PropTypes.string,
        /** Flag to assert that the user is selecting a date */
        isOpen: PropTypes.bool,
        /** Flag to apply correct style class to the component if it's in a Modal */
        inModal: PropTypes.bool,
    };

    static defaultProps = {
        checkInLabel: 'Check In',
        checkOutLabel: 'Check Out',
    };

    render() {
        const {
            checkInLabel,
            checkOutLabel,
            checkIn,
            checkOut,
            isOpen,
            inModal,
        } = this.props;
        const strokeWidth = checkIn && checkOut ? 2 : 1;

        const datesSelected = !!(checkIn && checkOut);
        const isSelectingCheckOut = checkIn && isOpen;
        const isSelectingCheckIn = !checkIn && isOpen;

        const classes = classNames('CheckInCheckOut', {
            'CheckInCheckOut--modal': inModal,
        });

        return (
            <span className={classes}>
                <Label
                    label={checkInLabel}
                    date={checkIn}
                    isHighlighted={datesSelected || isSelectingCheckIn}
                />
                <span className="CheckInCheckOut__arrow">
                    <SVGIcon
                        strokeWidth={strokeWidth}
                        id="ARROW_RIGHT__16"
                        markup={ARROW_RIGHT__24}
                    />
                </span>
                <Label
                    label={checkOutLabel}
                    date={checkOut}
                    isHighlighted={datesSelected || isSelectingCheckOut}
                />
            </span>
        );
    }
}
